/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailResponseDto
 */
export interface EmailResponseDto {
    /**
     * Whether the email was sent successfully
     * @type {boolean}
     * @memberof EmailResponseDto
     */
    success: boolean;
    /**
     * Response message
     * @type {string}
     * @memberof EmailResponseDto
     */
    message: string;
    /**
     * Recipient email address
     * @type {string}
     * @memberof EmailResponseDto
     */
    to: string;
}

/**
 * Check if a given object implements the EmailResponseDto interface.
 */
export function instanceOfEmailResponseDto(value: object): value is EmailResponseDto {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function EmailResponseDtoFromJSON(json: any): EmailResponseDto {
    return EmailResponseDtoFromJSONTyped(json, false);
}

export function EmailResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'to': json['to'],
    };
}

export function EmailResponseDtoToJSON(json: any): EmailResponseDto {
    return EmailResponseDtoToJSONTyped(json, false);
}

export function EmailResponseDtoToJSONTyped(value?: EmailResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'to': value['to'],
    };
}

